/**
 * Entry of a page with the full search, results or basket (bundled as assets/dist/booking.min.js).
 *
 * Mounts the ONE app into every block. POST /start was already sent by the inline script in the head
 * (window.papounanBookingStart, full pages only): the API client uses that answer instead of asking again.
 */
import { mountBlocks } from './app.js';
import { createApi } from './api.js';
import { readPage, publishApi } from './page.js';

const page = readPage();
if (page.nodes.length && page.payload) {
	const api = publishApi(createApi(page.payload.api, { early: window.papounanBookingStart || null }));
	mountBlocks(page.nodes, {
		api,
		i18n: page.i18n,
		contact: page.payload.contact || null,
		display: page.payload.display || {},
		params: page.params,
		today: page.today
	});
}
